import axios from 'axios';

const updateProfileApi = async (values) => {
  try {
    const res = await axios.post('/auth/updateProfile', values, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return res;
  } catch (error) {
    throw new Error(error);
  }
};

export default updateProfileApi;
